import { render, staticRenderFns } from "./PuzzleFencesList.vue?vue&type=template&id=2de55e07"
import script from "./PuzzleFencesList.vue?vue&type=script&lang=js"
export * from "./PuzzleFencesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports